export default {
	apiKey: 'AIzaSyA4v0xNfROiTBl2mDRAy64GPGRlBItea8s',
	authDomain: 'dbdomicanastas.firebaseapp.com',
	databaseURL: 'https://dbdomicanastas.firebaseio.com',
	projectId: 'dbdomicanastas',
	storageBucket: 'dbdomicanastas.appspot.com',
	messagingSenderId: '735146690357',
	appId: '1:735146690357:web:42007e6c5230ad62626e7c',
	measurementId: 'G-8C8J97PTB4'
};
